import React from 'react';

import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material';

import { NavLink } from '@kamernet/core/Routing/NavLink';

import styles from './Breadcrumbs.module.css';

export interface BreadcrumbsProps {
  children: React.ReactNode;
}

export const Breadcrumbs = ({ children }: BreadcrumbsProps) => {
  return (
    // eslint-disable-next-line custom/no-restricted-translation
    <MuiBreadcrumbs
      separator=">"
      aria-label="Page breadcrumbs"
      className={styles.root}
    >
      {children}
    </MuiBreadcrumbs>
  );
};

export type BreadcrumbsLinkProps<ComponentType = typeof NavLink.Anchor> = {
  component?: ComponentType;
  'data-testid'?: string;
  // @ts-ignore
} & Omit<React.ComponentProps<ComponentType>, 'component'>;

// eslint-disable-next-line react/function-component-definition
function BreadcrumbsLink<ComponentType = typeof NavLink.Anchor>({
  // @ts-ignore
  component = NavLink.Anchor,
  // @ts-ignore
  children,
  'data-testid': testid,
  ...props
}: BreadcrumbsLinkProps<ComponentType>) {
  const Component = component;

  return (
    // @ts-ignore
    <Component
      data-testid={testid}
      underline="none"
      color="secondary"
      {...props}
    >
      {children}
    </Component>
  );
}

Breadcrumbs.Link = BreadcrumbsLink;

export interface BreadcrumbsTextProps {
  children: React.ReactNode;
  isActive?: boolean;
  'data-testid'?: string;
}

// eslint-disable-next-line react/function-component-definition
Breadcrumbs.Text = function BreadcrumbsText({
  children,
  isActive,
  'data-testid': testid,
}: BreadcrumbsTextProps) {
  return (
    <span
      className={isActive ? styles.active : styles.text}
      data-testid={testid}
    >
      {children}
    </span>
  );
};
